<template>
  <CafeteriaRequestsList/>
</template>
<script>
import CafeteriaRequestsList from '@/components/modules/cafeteria/requests/list'
export default {
  name: 'CafeteriaRequests',
  components: {
    CafeteriaRequestsList
  }
}
</script>



// WEBPACK FOOTER //
// src/views/cafeteria/requests/list.vue